import AccountItem from './AccountItem.js';
export default AccountItem;



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/AccountItem/index.js